import type { OperatingPoint, OperatingPointDataSet } from "@/components/types";
import type { PumpTornadoChartContext } from "../../d";
import { convert } from "@/libs/units";

export const getOperatingPointsBhp = (
  context: PumpTornadoChartContext
): OperatingPointDataSet => {
  const {
    isScenarioEspShore,
    pumpRequiredBrakeHP,
    totalRequiredBrakeHP,
    // pumpIntakeFlowRateBBLD,
    pumpDischargeFlowRateBBLD,
    baseXUnit,
    targetXUnit,
    targetXUnitLabel,
    baseBhpYUnit,
    targetBhpYUnit,
    targetBhpYUnitLabel
  } = context;
  const pumpBhpPoint = {
    x: pumpDischargeFlowRateBBLD,
    y: pumpRequiredBrakeHP
  };
  const totalBhpPoint = {
    x: pumpDischargeFlowRateBBLD,
    y: totalRequiredBrakeHP
  };

  const operatingPoints: OperatingPoint[] = [];
  if (isFinite(pumpRequiredBrakeHP)) {
    operatingPoints.push({
      label: "Pump",
      color: "var(--plotColor1)",
      rawPoint: pumpBhpPoint,
      point: {
        ...pumpBhpPoint,
        x: convert(pumpBhpPoint.x, baseXUnit, targetXUnit),
        y: convert(pumpBhpPoint.y, baseBhpYUnit, targetBhpYUnit)
      },
      xLabel: targetXUnitLabel,
      yLabel: targetBhpYUnitLabel
    });

    // Only show total bhp point for ESP shore scenario
    if (isScenarioEspShore) {
      operatingPoints.push({
        label: "Total",
        color: "var(--plotColor2)",
        rawPoint: totalBhpPoint,
        point: {
          ...totalBhpPoint,
          x: convert(totalBhpPoint.x, baseXUnit, targetXUnit),
          y: convert(totalBhpPoint.y, baseBhpYUnit, targetBhpYUnit)
        },
        xLabel: targetXUnitLabel,
        yLabel: targetBhpYUnitLabel
      });
    }
  }
  return { operatingPoints };
};
